<div class="tt-o-listbox">
  <button ref="trigger"
          type="button"
          class="tt-o-listbox__btn"
          :class="{ 'tt-o-listbox__btn--with-label': !!label }"
          aria-haspopup="listbox"
          :aria-labelledby="'tt-lb-btn-' + ident"
          :id="'tt-lb-btn-' + ident"
          :aria-expanded="isExpanded.toString()"
          @click="onTriggerClicked"
          :disabled="disabled">
      <span v-if="label" class="tt-o-listbox__label" v-html="label"></span>
      <span class="tt-o-listbox__btn-label" v-html="btnValue"></span>
      <tt-icon class="tt-o-listbox__btn-icon" :class="{ 'tt-o-listbox__btn-icon--open': isExpanded }" size="sm" name="caret-down"></tt-icon>
  </button>
  <ul ref="list" 
      v-show="isExpanded"
      class="tt-o-listbox__list"
      :class="{ 'tt-o-listbox__list--has-selection': hasSelection }"
      @blur="onListBlur"
      @keydown="handleKeydown"
      tabindex="-1"
      role="listbox"
      :aria-activedescendant="activeDesc"
      :aria-labelledby="'tt-lb-btn-' + ident">
    <li v-for="(opt, index) in optionsData"
        :id="opt.id"
        ref="option"
        class="tt-o-listbox__option"
        :class="[{'tt-o-listbox__option--is-active': index === activeIndex}]"
        @click.prevent="selectOption(index)"
        role="option"
        :aria-selected="opt.isSelected">
      <span class="tt-o-listbox__option-icon-wrap">
        <tt-icon v-if="opt.iconName" :name="opt.iconName" size="md" :ariaHidden="!opt.isSelected" :title="opt.iconTitle" class="tt-o-listbox__option-icon"></tt-icon>  
      </span>
      <template v-if="isRating">
        <div class="tt-o-listbox__rating-option" :aria-label="opt.label">
          <tt-icon v-for="n in 5" :name="'star--' + ((5 - index) >= n ? 'full' : 'empty')" class="tt-c-rating__rating-option-icon"></tt-icon>
        </div>
        <span class="tt-o-listbox__option-text">{{opt.ratingCount}}</span>
      </template>
      <span v-else class="tt-o-listbox__option-text" v-html="opt.label"></span>      
    </li>
  </ul>
</div>